import { render, staticRenderFns } from "./AddressModalForm.vue?vue&type=template&id=8f9555c6&scoped=true"
import script from "./AddressModalForm.vue?vue&type=script&lang=js"
export * from "./AddressModalForm.vue?vue&type=script&lang=js"
import style0 from "./AddressModalForm.vue?vue&type=style&index=0&id=8f9555c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9555c6",
  null
  
)

export default component.exports